import {
  MdManageHistory,
  MdPublic,
  MdScreenshotMonitor,
  MdOutlineAdminPanelSettings,
  MdMessage,
} from "react-icons/md";
import { FaBuilding } from "react-icons/fa";
import { ImProfile } from "react-icons/im";
import { RiAdvertisementLine } from "react-icons/ri";
import { IoIosStats } from "react-icons/io";
import { GiSandsOfTime } from "react-icons/gi";
const links = [
  {
    text: "המשרדים שלי",
    path: "all-office",
    icon: <FaBuilding />,
    role: ["user", "maintenance", "advertiser"],
  },
  {
    text: "הבניינים שלי",
    path: "all-buildings",
    icon: <MdScreenshotMonitor />,
    role: ["user", "maintenance", "advertiser"],
  },
  {
    text: "הודעות",
    path: "show-messages",
    icon: <MdMessage />,
    role: ["maintenance", "admin", "advertiser","user"],
  },
  {
    text: "הקמפיינים שלי",
    path: "all-advertisement",
    icon: <RiAdvertisementLine />,
    role: ["advertiser", "admin", "maintenance"],
  },
  {
    text: "תזמוני קמפיינים",
    path: "all-schedules",
    icon: <GiSandsOfTime />, 
    role: ["admin", "maintenance"],
  },
  {
    text: "ניהול המערכת",
    path: "admin",
    icon: <MdOutlineAdminPanelSettings />,
    role: ["admin"],
  },

  {
    text: "הפרסומים שלנו",
    path: "all-advertisement",
    icon: <MdPublic />,
    role: ["admin"],
  },
  {
    text: "סטטיסטיקה",
    path: "stats",
    icon: <IoIosStats />,
    role: ["user", "admin", "maintenance"],
  },
  {
    text: "פרופיל",
    path: "Profile",
    icon: <MdPublic />,
    role: ["admin"],
  },
];

export default links;
